import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { SiaSelectBoxComponent } from '@sia/inputs';
import {
  FileService,
  jsonDeepClone,
  SiaArchivePath,
  SiaFileArchive,
} from '@sia/shared';
import { SiaCoreFileSystemComponent } from '../../components/sia-core-file-system/sia-core-file-system.component';

@Component({
  selector: 'sia-system-file-archives-page',
  templateUrl: './sia-system-file-archives-page.component.html',
  styleUrls: ['./sia-system-file-archives-page.component.scss'],
  standalone: true,
  imports: [SiaSelectBoxComponent, SiaCoreFileSystemComponent],
})
export class SiaSystemFileArchivesPageComponent {
  private siaFileSystemService = inject(FileService);
  private cdr = inject(ChangeDetectorRef);

  archives: SiaFileArchive[] = [];
  archivesDataSource: { id?: string; description?: string }[] = [];
  path?: SiaArchivePath | undefined | null;
  private _selectedArchive?: SiaFileArchive | null;
  get selectedArchive(): SiaFileArchive | null | undefined {
    return this._selectedArchive;
  }
  set selectedArchive(value: SiaFileArchive | null | undefined) {
    // console.log('selectedArchive', value);
    // console.log('selectedArchive', value?.path);
    this._selectedArchive = value;
    this.path = {
      path: value?.path ?? '',
      isRelativePath: value?.isRelativePath,
      id: value?.id,
      isSystemArchive: true,
      publicFolder: value?.publicFolder,
      showFileTree: true,
    };
    // console.log(this.path);
  }

  /** Inserted by Angular inject() migration for backwards compatibility */

  /**
   *
   */
  constructor() {
    this.loadArchives();
  }

  loadArchives() {
    this.archives = [];
    this.archivesDataSource = [];
    this.path = null;
    this.selectedArchive = null;
    this.siaFileSystemService
      .getSystemArchives()
      .then((archives: SiaFileArchive[]) => {
        if (!archives || archives.length == 0) {
          return;
        }
        this.archives = archives;
        this.processArchives();
      });
  }

  selectedArchiveChanged(event: string) {
    // console.log(event);
    this.selectedArchive = this.archives.find((a) => a.id == event);
  }
  async processArchives() {
    await this.archives.forEach(async (archive) => {
      this.archivesDataSource.push({
        id: archive.id,
        description: archive.description,
      });
    });
    this.archivesDataSource = jsonDeepClone(this.archivesDataSource);
    if (this.archives.length > 0) {
      this.selectedArchive = this.archives[0];
    }
    this.cdr.detectChanges();
  }
}
